/* Schuifrail: een rij die je zijwaarts schuift, met pijlen.

   De rail zelf is gewoon een overflow-x: auto — slepen, vegen en een trackpad
   werken zonder dit bestand. Dit script zet alleen de pijlen aan, en alleen
   als er werkelijk iets te schuiven valt: knoppen die niets doen horen er
   niet te staan.

   Gebruik:
     <div data-schuifrail>
       <button data-schuifrail-terug hidden>…</button>
       <button data-schuifrail-verder hidden>…</button>
       <ul data-schuifrail-baan>…</ul>
     </div>
*/

(function () {
  'use strict';

  document.querySelectorAll('[data-schuifrail]').forEach(function (wortel) {
    var baan = wortel.querySelector('[data-schuifrail-baan]');
    var terug = wortel.querySelector('[data-schuifrail-terug]');
    var verder = wortel.querySelector('[data-schuifrail-verder]');
    if (!baan || !terug || !verder) return;

    function schuifbaar() {
      return baan.scrollWidth > baan.clientWidth + 2;
    }

    /* Bijna een schermbreedte per klik: het laatste zichtbare kaartje blijft
       in beeld, zodat je ziet dat de rij doorloopt. */
    function stap() {
      return Math.max(baan.clientWidth * 0.85, 200);
    }

    function stemAf() {
      var kan = schuifbaar();
      terug.hidden = !kan;
      verder.hidden = !kan;
      if (!kan) return;
      // 2px speling: scrollLeft komt in browsers met een breuk terug.
      terug.disabled = baan.scrollLeft < 2;
      verder.disabled = baan.scrollLeft + baan.clientWidth >= baan.scrollWidth - 2;
    }

    terug.addEventListener('click', function () { baan.scrollBy({ left: -stap(), behavior: 'smooth' }); });
    verder.addEventListener('click', function () { baan.scrollBy({ left: stap(), behavior: 'smooth' }); });
    baan.addEventListener('scroll', stemAf, { passive: true });
    window.addEventListener('resize', stemAf);
    stemAf();
  });
})();
